export const environment = {
  production: true,
  hmr: false,
  limitAccessToSubjectsByOrg: false,
  allowAdminsToCreateOrganisations: false,
  timeRecordingInMinutes: false,
  enableCasePreparationFeatures: false,
  enableGridSizing: false,
  enableGeoLocation: false,
  enableFOIFeature: false,
  enableMobileView: false,
  enableBIDashboardAccess: false,
  enableFTSU2WayComms: false,
  enableRAF2WayComms: false,
  enableFTSUTranslate: false,
  enableRAFTranslate: false,
  currentUserIsMultiOrgAdmin: false,
  enableRetentionFeature: true,
  enableEmailReferrals: false,
  requirePermissionToCloseCases: false,
  CheckListV2:true,
  appName: 'TFLInCase365',
  appInsights: {
    instrumentationKey: '',
  },
};
